import React from 'react';
import './Aboutus.css'; // Import the CSS file
import image1 from '../aboutus/images/img1.jpg';
import image2 from '../aboutus/images/img2.jpg';
import image3 from '../aboutus/images/img3.png';
import image5 from '../aboutus/images/img5.png';
import image6 from '../aboutus/images/img6.jpg';
import image7 from '../aboutus/images/img7new.png';

const AboutUs = ({ theme, toggleTheme }) => {
    return (
        <div className={`about-us-container fade-in justify-content-center ${theme}`}>
            {/* Section 1: Information about the Movie Recommendation Website */}
            <section className="about-section">
                <h1 style={{textAlign:"center"}}>About CineSage </h1>
                <p className={theme === 'light' ? 'light-text' : 'dark-text'}>
                    Welcome to CineSage! We're here to make your movie nights awesome. Our team loves movies as much as you do, and we've made it our mission to help you find the perfect films effortlessly.

                    At CineSage, we believe everyone should have access to great movies that match their taste. Whether you're into heartwarming stories, thrilling adventures, or hilarious comedies, we've got something special for you.

                    Discovering movies on our website is easy and fun. We've designed our platform to make finding recommendations a breeze. Whether you know exactly what you're looking for or want to try something new, we've got your back.

                    Come join us on this movie-watching adventure. Let CineSage be your movie buddy, guiding you to the best films for every mood. Movie night will never be the same again!
                    <br/>
                    <span className="image-container">
                        <img src={image1} alt="Image1" />
                        <img src={image2} alt="Image2" />
                        <img src={image3} alt="Image3" />
                    </span>
                </p>
            </section>

            {/* Section 2: Information about Searching and Getting Recommendations */}
            <section className="about-section">
                <h1 style={{textAlign:"center"}}>CineSage Features</h1>
                <p className={`animated-text ${theme === 'light' ? 'light-text' : 'dark-text'}`}>
                    With CineSage, you can effortlessly search for movies based on titles, genres, and release years. Whether you're in the mood for a classic or craving the latest releases, our advanced search functionality ensures you find exactly what you're looking for.

                    But that's not all – we understand the importance of sorting options. That's why CineSage allows you to sort your movie results based on release years. Whether you want to explore films from a specific era or catch up on the latest cinematic trends, our sorting feature makes it a breeze.

                    We also know that your favorites matter, and that's why CineSage goes the extra mile. By curating personalized recommendations based on your favorite movies, we ensure that every film suggestion is tailored to your unique taste. Our goal is to make your movie nights exceptional, filled with films that resonate with you. Join us at CineSage, where movie magic meets user-friendly features!
                </p>
                <span className="image-container">
                    <img src={image5} alt="Image5" />
                    <img src={image7} style={{ height: '500%', width: '27%', transform: 'scale(1.3)' }} alt="Image7" />
                    <img src={image6} alt="Image6" />
                </span>
            </section>

            {/* Section 3: Information about the Team */}
            <section className="about-section">
                <h1 style={{textAlign:"center"}}>CinSage Team</h1>
                <p className={`animated-text ${theme === 'light' ? 'light-text' : 'dark-text'}`}>
                    Introducing the CineSage Team – a passionate group of movie enthusiasts dedicated to enhancing your cinematic experience! Our team is committed to curating the finest movie recommendations and creating a platform that makes discovering your next favorite film a joyous journey.

                    At CineSage, we believe in the power of community and connection. Our team consists of diverse individuals, each with a deep love for cinema and a shared mission to bring you personalized movie suggestions that match your unique taste.

                    We value your feedback and welcome you to connect with us. Whether you have suggestions, questions, or just want to share your thoughts on our platform, feel free to reach out! Our user-friendly Contact Us form is designed to make it easy for you to connect with the CineSage Team. Your input is invaluable, and we look forward to hearing from you as we continue to enhance your movie-watching experience. Thank you for being a part of the CineSage community!
                </p>
            </section>
        </div>
    );
};

export default AboutUs;
